import React from 'react'
import { Link } from 'react-router-dom'

const Tools = () => {
    return (
        <>
            <div className="container every_page_mg_top">
                <div className="row">
                    <div className="col-md-6" style={{ backgroundColor: '--first-color' }}>
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/TypingMaster"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Typing Master</h3>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/WhiteBoard"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">WhiteBoard</h3>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/DynamicDocx"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Ms Word</h3>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/RemoveBg"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Remove Bg</h3>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/TryEditor"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Online Compiler</h3>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/CssBoxShadowGenerate"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Box Shadow Genarator</h3>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Tools